import { render } from "./ViewsCatalog.vue?vue&type=template&id=be2b09c2"
import script from "./ViewsCatalog.vue?vue&type=script&lang=js"
export * from "./ViewsCatalog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__